export default "__VITE_ASSET__Dx4LhLri__"